import { useState } from "react";
import type { Material } from "@/types/material";
import { MaterialTabNav, type MaterialTab } from "./MaterialTabNav";
import { OverviewTab } from "./tabs/OverviewTab";
import { UomPackSizeTab } from "./tabs/UomPackSizeTab";
import { UsedInRecipesTab } from "./tabs/UsedInRecipesTab";

interface MaterialDetailViewProps {
  material: Material;
  canEdit: boolean;
  onEdit: () => void;
}

export function MaterialDetailView({ material, canEdit, onEdit }: MaterialDetailViewProps) {
  const [activeTab, setActiveTab] = useState<MaterialTab>("overview");

  return (
    <>
      <div className="px-3">
        <MaterialTabNav activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div className="pb-10" role="tabpanel">
        {activeTab === "overview" && (
          <OverviewTab
            material={material}
            canEdit={canEdit}
            onEdit={onEdit}
            onOpenUomTab={() => setActiveTab("uomPackSize")}
          />
        )}
        {activeTab === "uomPackSize" && <UomPackSizeTab materialId={material.id} canEdit={canEdit} />}
        {activeTab === "usedInRecipes" && <UsedInRecipesTab materialId={material.id} />}
      </div>
    </>
  );
}
